import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export default function Terminos() {
  // For mobile: collapsible sections
  const [expandedSections, setExpandedSections] = useState<number[]>([]);
  const toggleSection = (sectionId: number) => {
    setExpandedSections(prev => prev.includes(sectionId) ? prev.filter(id => id !== sectionId) : [...prev, sectionId]);
  };
  const isExpanded = (sectionId: number) => expandedSections.includes(sectionId);
  // Helper component for section titles
  const SectionTitle = ({
    id,
    title
  }: {
    id: number;
    title: string;
  }) => <div className="mb-4 md:mb-6" data-id="element-607">
      <div className="flex justify-between items-center cursor-pointer md:cursor-default" onClick={() => toggleSection(id)} data-id="element-608">
        <h3 className="text-lg md:text-xl font-bold text-[#0E1113]" data-id="element-609">
          {id}) {title}
        </h3>
        <span className="md:hidden" data-id="element-610">
          {isExpanded(id) ? <ChevronUpIcon className="h-5 w-5 text-[#004E5A]" data-id="element-611" /> : <ChevronDownIcon className="h-5 w-5 text-[#004E5A]" data-id="element-612" />}
        </span>
      </div>
      <div className="h-0.5 w-full bg-gray-100 mt-2" data-id="element-613"></div>
    </div>;
  // Helper component for section content
  const SectionContent = ({
    id,
    children
  }: {
    id: number;
    children: React.ReactNode;
  }) => <div className={`mb-8 ${!isExpanded(id) && 'hidden md:block'}`} data-id="element-614">
      {children}
    </div>;
  return <section className="bg-white py-8 md:py-16" data-id="element-615">
      <div className="container mx-auto max-w-4xl px-4" data-id="element-616">
        <h1 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 text-[#0E1113]" data-id="element-617">
          Términos y Condiciones y Política de Privacidad de Creditual
        </h1>
        <div className="text-sm md:text-base text-[#5B6166] mb-8" data-id="element-618">
          <p className="italic" data-id="element-619">Última actualización: 13 de octubre de 2025</p>
          <p className="italic" data-id="element-620">Vigente en: República de Chile</p>
        </div>
        {/* Section 1 */}
        <SectionTitle id={1} title="Quiénes somos y qué hacemos" data-id="element-621" />
        <SectionContent id={1} data-id="element-622">
          <p className="text-[#5B6166] mb-4" data-id="element-623">
            Creditual es una plataforma tecnológica que te permite ingresar una
            sola vez tus datos y enviar solicitudes de evaluación de créditos
            hipotecarios, de consumo y/o automotrices a distintas entidades
            financieras, conforme elijas. No somos banco ni otorgamos créditos:
            facilitamos el flujo de información entre personas usuarias y
            potenciales proveedores financieros. Las decisiones comerciales,
            tasas, plazos, aprobaciones y montos dependen exclusivamente de cada
            entidad financiera.
          </p>
        </SectionContent>
        {/* Section 2 */}
        <SectionTitle id={2} title="Aceptación de este acuerdo" data-id="element-624" />
        <SectionContent id={2} data-id="element-625">
          <p className="text-[#5B6166] mb-4" data-id="element-626">
            Al usar la Plataforma aceptas íntegramente estos Términos y
            Condiciones y esta Política de Privacidad (conjuntamente, el
            "Acuerdo"). Si no estás de acuerdo, por favor no uses la Plataforma.
            Podremos actualizar este Acuerdo; publicaremos la versión vigente
            con fecha de actualización.
          </p>
        </SectionContent>
        {/* Section 3 */}
        <SectionTitle id={3} title="Elegibilidad y veracidad de la información" data-id="element-627" />
        <SectionContent id={3} data-id="element-628">
          <p className="text-[#5B6166] mb-4" data-id="element-629">
            Debes ser mayor de 18 años, tener capacidad legal para contratar y
            proporcionar información veraz, completa y actualizada (por ejemplo:
            identidad, RUT, ingresos, contacto, comprobantes). Eres responsable
            de mantener tus datos al día.
          </p>
        </SectionContent>
        {/* Section 4 */}
        <SectionTitle id={4} title="Registro, cuenta y seguridad" data-id="element-630" />
        <SectionContent id={4} data-id="element-631">
          <p className="text-[#5B6166] mb-4" data-id="element-632">
            Podrás crear una cuenta con email y contraseña, o iniciar sesión con
            SSO (Google) si habilitado. Debes resguardar tus credenciales.
            Podemos solicitar verificación de contacto (email,
            teléfono/WhatsApp) y validaciones básicas (formato de RUT,
            existencia de dominio de email) para mejorar la calidad de los
            envíos.
          </p>
        </SectionContent>
        {/* Section 5 */}
        <SectionTitle id={5} title="Qué puedes y no puedes hacer" data-id="element-633" />
        <SectionContent id={5} data-id="element-634">
          <p className="text-[#5B6166] mb-4" data-id="element-635">
            Usarás la Plataforma conforme la ley y este Acuerdo. Está prohibido:
            (i) usar datos falsos o de terceros sin autorización; (ii) vulnerar
            seguridad, extraer o "scrapear" información; (iii) intentar
            interferir en el funcionamiento; (iv) usar la Plataforma para
            actividades ilícitas.
          </p>
        </SectionContent>
        {/* Section 6 */}
        <SectionTitle id={6} title="Rol de Creditual (disclaimer esencial)" data-id="element-636" />
        <SectionContent id={6} data-id="element-637">
          <p className="text-[#5B6166] mb-4" data-id="element-638">
            No asesoramos financieramente ni recomendamos un proveedor
            específico. Brindamos herramientas para comparar y canalizar
            solicitudes.
          </p>
          <p className="text-[#5B6166] mb-4" data-id="element-639">
            No garantizamos preaprobaciones ni aprobaciones. Las ofertas y
            condiciones son definidas por cada entidad financiera, bajo su
            propia evaluación de riesgo.
          </p>
          <p className="text-[#5B6166] mb-4" data-id="element-640">
            Cuando corresponda, cumpliremos las obligaciones regulatorias
            aplicables al ecosistema fintech y de servicios financieros en
            Chile, incluyendo registros ante la CMF si fueran exigibles por la
            Ley 21.521 y sus normas.
          </p>
        </SectionContent>
        {/* Section 7 */}
        <SectionTitle id={7} title="Precios y comisiones" data-id="element-641" />
        <SectionContent id={7} data-id="element-642">
          <p className="text-[#5B6166] mb-4" data-id="element-643">
            El uso de la Plataforma puede ser gratuito para usuarios finales o
            puede contemplar cobros y/o comisiones (p. ej., servicios premium,
            validaciones, o cargos a proveedores). Cualquier precio, comisión o
            cargo aplicable será informado de forma previa, clara y oportuna
            antes de que aceptes.
          </p>
        </SectionContent>
        {/* Section 8 */}
        <SectionTitle id={8} title="Propiedad intelectual" data-id="element-644" />
        <SectionContent id={8} data-id="element-645">
          <p className="text-[#5B6166] mb-4" data-id="element-646">
            Todos los derechos sobre el software, marcas, logotipos, textos,
            interfaces, diseños y código de la Plataforma pertenecen a Creditual
            o a sus licenciantes. No adquieres derecho de propiedad alguno por
            usar la Plataforma.
          </p>
        </SectionContent>
        {/* Section 9 */}
        <SectionTitle id={9} title="Disponibilidad y cambios en el servicio" data-id="element-647" />
        <SectionContent id={9} data-id="element-648">
          <p className="text-[#5B6166] mb-4" data-id="element-649">
            Podemos modificar, actualizar, suspender o terminar total o
            parcialmente la Plataforma en cualquier momento. Procuraremos
            comunicar cambios relevantes. Puede haber intermitencias o errores,
            pese a nuestros esfuerzos razonables por mantener continuidad y
            seguridad.
          </p>
        </SectionContent>
        {/* Section 10 */}
        <SectionTitle id={10} title="Limitación de responsabilidad" data-id="element-650" />
        <SectionContent id={10} data-id="element-651">
          <p className="text-[#5B6166] mb-4" data-id="element-652">
            En la medida permitida por la ley, Creditual no será responsable
            por: (i) decisiones u ofertas de terceros (bancos/financieras), (ii)
            pérdidas de datos derivadas de uso indebido de tus credenciales,
            (iii) daños indirectos, incidentales o consecuenciales. Nada en este
            Acuerdo limita derechos irrenunciables como consumidor conforme Ley
            19.496.
          </p>
        </SectionContent>
        {/* Section 11 */}
        <SectionTitle id={11} title="Enlaces a terceros" data-id="element-653" />
        <SectionContent id={11} data-id="element-654">
          <p className="text-[#5B6166] mb-4" data-id="element-655">
            La Plataforma puede contener enlaces a sitios de terceros. Esos
            sitios tienen sus propios términos y políticas. Creditual no
            controla ni es responsable por su contenido o prácticas.
          </p>
        </SectionContent>
        {/* Section 12 */}
        <SectionTitle id={12} title="Política de Privacidad (Chile)" data-id="element-656" />
        <SectionContent id={12} data-id="element-657">
          <div className="ml-4 md:ml-6" data-id="element-658">
            <h4 className="font-medium text-[#0E1113] mb-2" data-id="element-659">
              12.1 Base legal y alcance
            </h4>
            <p className="text-[#5B6166] mb-4" data-id="element-660">
              Tratamos datos personales conforme la Ley N° 19.628 sobre
              protección de la vida privada. Esta sección explica qué datos
              tratamos, para qué, por cuánto tiempo y con quién los compartimos.
            </p>
            <h4 className="font-medium text-[#0E1113] mb-2" data-id="element-661">
              12.2 Datos que tratamos
            </h4>
            <ul className="list-disc ml-5 mb-4 text-[#5B6166]" data-id="element-662">
              <li data-id="element-663">
                Identificación y contacto: nombre, RUT, email,
                teléfono/WhatsApp.
              </li>
              <li data-id="element-664">
                Datos financieros y socioeconómicos que tú nos entregas para
                gestionar tus solicitudes (ingresos, empleo/actividad,
                antigüedad, deudas declaradas, patrimonio declarado, cargas).
              </li>
              <li data-id="element-665">
                Soportes documentales que subas (liquidaciones, boletas, DJ,
                certificados, etc.).
              </li>
              <li data-id="element-666">
                Datos de uso y técnicos: logs, IP, dispositivo, navegador,
                cookies (ver 12.9).
              </li>
              <li data-id="element-667">Preferencias de entidades y tipo de crédito.</li>
            </ul>
            <h4 className="font-medium text-[#0E1113] mb-2" data-id="element-668">
              12.3 Finalidades del tratamiento
            </h4>
            <p className="text-[#5B6166] mb-4" data-id="element-669">
              a) Prestar el servicio de preparación y envío de solicitudes de
              evaluación a entidades que tú selecciones; b) Verificar y mejorar
              la calidad de los datos (validaciones de formato, contacto y
              consistencias básicas); c) Comunicarnos contigo por
              email/SMS/WhatsApp sobre tu proceso; d) Cumplir obligaciones
              legales y requerimientos de autoridad; e) Mejorar la Plataforma
              (analítica, métricas, experiencia de usuario); f) Prevención de
              fraudes y seguridad; g) Marketing propio con tu consentimiento (y
              opción de opt-out en todo momento).
            </p>
            <p className="text-[#5B6166] mb-4" data-id="element-670">
              Las finalidades (a)-(f) se basan en ejecución del
              contrato/servicio y cumplimiento legal; (g) requiere
              consentimiento cuando aplique.
            </p>
            <h4 className="font-medium text-[#0E1113] mb-2" data-id="element-671">
              12.4 Origen de los datos
            </h4>
            <p className="text-[#5B6166] mb-4" data-id="element-672">
              Principalmente los aportas tú. También podemos recibir información
              del proveedor financiero (estado de tu postulación) estrictamente
              para gestionar tu proceso.
            </p>
            <h4 className="font-medium text-[#0E1113] mb-2" data-id="element-673">
              12.5 Con quién compartimos tus datos
            </h4>
            <ul className="list-disc ml-5 mb-4 text-[#5B6166]" data-id="element-674">
              <li data-id="element-675">
                Instituciones financieras que tú eliges para enviar tus
                antecedentes.
              </li>
              <li data-id="element-676">
                Proveedores tecnológicos (hosting, mensajería, verificación,
                analítica) bajo contratos de encargo de tratamiento y
                confidencialidad.
              </li>
              <li data-id="element-677">Autoridades cuando la ley lo exija.</li>
              <li data-id="element-678">No vendemos tus datos personales.</li>
            </ul>
            <h4 className="font-medium text-[#0E1113] mb-2" data-id="element-679">
              12.6 Transferencias internacionales
            </h4>
            <p className="text-[#5B6166] mb-4" data-id="element-680">
              Si algún proveedor tecnológico aloja o procesa datos fuera de
              Chile, adoptaremos medidas contractuales y técnicas razonables
              para resguardar un nivel adecuado de protección.
            </p>
            <h4 className="font-medium text-[#0E1113] mb-2" data-id="element-681">
              12.7 Plazos de conservación
            </h4>
            <p className="text-[#5B6166] mb-4" data-id="element-682">
              Conservaremos tus datos mientras dure tu relación con Creditual y,
              luego, por el plazo necesario para cumplir obligaciones legales,
              defensa de intereses y trazabilidad. Pasado ese plazo, los
              eliminaremos o anonimizaremos de forma segura.
            </p>
            <h4 className="font-medium text-[#0E1113] mb-2" data-id="element-683">
              12.8 Tus derechos (ARCO)
            </h4>
            <p className="text-[#5B6166] mb-4" data-id="element-684">
              Puedes acceder, rectificar, cancelar/eliminar y oponerte al
              tratamiento de tus datos (ARCO), además de solicitar bloqueo o
              información sobre fines y destinatarios. Escríbenos a
              privacidad@creditual.cl (o canal indicado en la web).
              Responderemos en los plazos de la Ley 19.628.
            </p>
            <h4 className="font-medium text-[#0E1113] mb-2" data-id="element-685">
              12.9 Cookies y tecnologías similares
            </h4>
            <p className="text-[#5B6166] mb-4" data-id="element-686">
              Usamos cookies para recordar tu sesión, mejorar seguridad, medir
              uso y personalizar experiencia. Puedes configurar tu navegador
              para bloquearlas; algunas funciones podrían verse afectadas. El
              detalle de cookies (tipo, finalidad, vigencia) estará en nuestro
              Aviso de Cookies.
            </p>
            <h4 className="font-medium text-[#0E1113] mb-2" data-id="element-687">
              12.10 WhatsApp y comunicaciones
            </h4>
            <p className="text-[#5B6166] mb-4" data-id="element-688">
              Al ingresar tu número y optar por canal WhatsApp, nos autorizas a
              contactarte por ese medio sobre tu proceso y notificaciones del
              servicio. Puedes solicitar no recibir comunicaciones en cualquier
              momento (opt-out).
            </p>
            <h4 className="font-medium text-[#0E1113] mb-2" data-id="element-689">
              12.11 Seguridad de la información
            </h4>
            <p className="text-[#5B6166] mb-4" data-id="element-690">
              Aplicamos medidas técnicas y organizativas razonables (cifrado en
              tránsito, controles de acceso, registro de eventos, segregación de
              ambientes). Ningún sistema es 100% infalible, pero trabajamos para
              prevenir, detectar y mitigar incidentes.
            </p>
          </div>
        </SectionContent>
        {/* Section 13 */}
        <SectionTitle id={13} title="Reclamaciones y soporte" data-id="element-691" />
        <SectionContent id={13} data-id="element-692">
          <p className="text-[#5B6166] mb-4" data-id="element-693">
            Si tienes un problema con el servicio, contáctanos primero a
            soporte@creditual.cl. Si no quedas conforme, puedes ejercer tus
            derechos como consumidor ante SERNAC conforme la Ley 19.496.
          </p>
        </SectionContent>
        {/* Section 14 */}
        <SectionTitle id={14} title="Terminación de cuenta" data-id="element-694" />
        <SectionContent id={14} data-id="element-695">
          <p className="text-[#5B6166] mb-4" data-id="element-696">
            Puedes solicitar el cierre de tu cuenta y la eliminación de tus
            datos personales (salvo conservación legal obligatoria). Podemos
            suspender o cerrar cuentas por incumplimiento del Acuerdo o uso
            indebido.
          </p>
        </SectionContent>
        {/* Section 15 */}
        <SectionTitle id={15} title="Cambios a este Acuerdo" data-id="element-697" />
        <SectionContent id={15} data-id="element-698">
          <p className="text-[#5B6166] mb-4" data-id="element-699">
            Podemos actualizar este Acuerdo para reflejar cambios legales o de
            la Plataforma. Publicaremos la fecha de vigencia y, si el cambio es
            relevante, te lo notificaremos por un canal razonable.
          </p>
        </SectionContent>
        {/* Section 16 */}
        <SectionTitle id={16} title="Ley aplicable y jurisdicción" data-id="element-700" />
        <SectionContent id={16} data-id="element-701">
          <p className="text-[#5B6166] mb-4" data-id="element-702">
            Este Acuerdo se rige por las leyes de la República de Chile. Para
            controversias, las partes se someten a los tribunales ordinarios de
            justicia de Santiago de Chile, sin perjuicio de derechos
            irrenunciables del consumidor.
          </p>
        </SectionContent>
        {/* Section 17 */}
        <SectionTitle id={17} title="Contacto" data-id="element-703" />
        <SectionContent id={17} data-id="element-704">
          <p className="text-[#5B6166] mb-1" data-id="element-705">
            Legal/Privacidad: privacidad@creditual.cl
          </p>
          <p className="text-[#5B6166] mb-1" data-id="element-706">Soporte: soporte@creditual.cl</p>
          <p className="text-[#5B6166] mb-4" data-id="element-707">Dirección: (completar)</p>
        </SectionContent>
        <div className="mt-8 text-center" data-id="element-708">
          <a href="/" className="inline-block px-5 py-2 md:px-6 md:py-3 bg-[#004E5A] text-white font-medium rounded-xl md:rounded-2xl hover:translate-y-[-2px] transition-transform" data-id="element-709">
            Volver a Creditual
          </a>
        </div>
      </div>
    </section>;
}